import React from 'react';

import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';

import Styles from 'styles/constants';
import { primitive } from 'styles/constants/primitives';

export const MARKER_DIMENSIONS = {
  width: 33,
  height: 45,
  viewBox: '0 0 33 45',
} as const;

const DESTINATION_PATHS = {
  background:
    'M16.789.327C8.333.327 1.494 7.166 1.494 15.62c0 11.471 15.295 28.405 15.295 28.405S32.084 27.092 32.084 15.62c0-8.455-6.84-15.294-15.295-15.294Z',
  content: 'M15.333 21.667v-5h3.334v5h4.166V15h2.5L17 7.5 8.667 15h2.5v6.667h4.166Z',
} as const;

const COLORS = {
  background: primitive.bk.$bbqBrown,
  content: primitive.bk.$white,
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SHADOW_STYLES: any = {
  shadowColor: Styles.shadowColor,
  shadowOffset: {
    width: 1.2,
    height: 1.2,
  },
  shadowRadius: 1.5,
  shadowOpacity: 0.8,
  elevation: 10, // for android
};

const defaultAccessibilityLabel = 'Destination marker';

interface DestinationMarkerProps extends SvgProps {
  accessibilityLabel?: string;
  testID?: string;
}

export const DestinationMarker: React.FC<DestinationMarkerProps> = ({
  accessibilityLabel,
  testID,
  ...svgProps
}) => {
  return (
    <Svg
      width={MARKER_DIMENSIONS.width}
      height={MARKER_DIMENSIONS.height}
      viewBox={MARKER_DIMENSIONS.viewBox}
      fill="none"
      style={SHADOW_STYLES}
      accessible={true}
      accessibilityLabel={accessibilityLabel || defaultAccessibilityLabel}
      testID={testID}
      {...svgProps}
    >
      <SvgPath d={DESTINATION_PATHS.background} fill={COLORS.background} />
      <SvgPath d={DESTINATION_PATHS.content} fill={COLORS.content} />
    </Svg>
  );
};

export const destinationMarkerSvg = `<svg width="${MARKER_DIMENSIONS.width}" height="${MARKER_DIMENSIONS.height}" viewBox="${MARKER_DIMENSIONS.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="${DESTINATION_PATHS.background}" fill="${COLORS.background}" />
  <path d="${DESTINATION_PATHS.content}" fill="${COLORS.content}" />
</svg>`;
